module.exports = __webpack_public_path__ + "static/media/IconTemplates_-49.d2d7c3ce.svg";